export enum eAssetType {
  STOCK = 1,
  FOREX = 2,
  CRIPTO = 3,
  FIIS = 4,
}

export interface AssetSuggestion {
  name: string;
  symbol: string;
  exchange: string;
  type: eAssetType;
  id: string;
  country_code: number;
  icon: string;
  currency_symbol: string;
  status: boolean;
}

export interface AssetDetails {
  status: number;
  name: string;
  symbol: string;
  type: eAssetType;
  country_code: number;
  exchange: string | null;
  currency_symbol: string;
  encoded_id: string;
  icon: string | null;
}

export interface MultipleAssetResponse {
  status: number;
  msg: string;
  data: AssetDetails[];
}

export interface AssetReport {
  id: number;
  investor_type: number;
  ai_model_resume: string;
  ai_sentiment: number;
  general_qnt_buy: number;
  general_qnt_sell: number;
  extra_buy: number;
  extra_sell: number;
  health_buy: number;
  health_sell: number;
  fundamental_buy: number;
  fundamental_sell: number;
  technical_buy: number;
  technical_sell: number;
  sentiment_buy: number;
  sentiment_sell: number;
  news_sentiment: number;
  tag1: string;
  tag2: string;
  tag3: string;
  likes: number;
  dislikes: number;
  created_at: string;
  updated_at: string;
}
